{
    "v": "5.9.6",
    "fr": 25,
    "ip": 0,
    "op": 50,
    "w": 500,
    "h": 500,
    "nm": "47 Lock",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 18, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 4,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.200000017881, 0.800000071526, 0.800000071526, 1], "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Lock 1",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 2, "s": [0] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 13, "s": [10] },
                        { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 20, "s": [10] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 26, "s": [-9] },
                        { "t": 36, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [189.985, 237.425, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [389.985, 437.425, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [17.271, 0],
                                        [0, 25.771],
                                        [-25.771, 0],
                                        [-8.068, -13.947]
                                    ],
                                    "o": [
                                        [-8.068, 13.947],
                                        [-25.771, 0],
                                        [0, -25.771],
                                        [17.271, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [43.541, 23.331],
                                        [3.121, 46.662],
                                        [-43.541, 0],
                                        [3.121, -46.662],
                                        [43.541, -23.331]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.667], "y": [1] },
                                        "o": { "x": [0.333], "y": [0] },
                                        "t": 23,
                                        "s": [100]
                                    },
                                    { "t": 39, "s": [0] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.667], "y": [1] },
                                        "o": { "x": [0.333], "y": [0] },
                                        "t": 32,
                                        "s": [100]
                                    },
                                    { "t": 48, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [246.879, 344.101], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "C 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [17.271, 0],
                                        [0, 25.771],
                                        [-25.771, 0],
                                        [-8.068, -13.947]
                                    ],
                                    "o": [
                                        [-8.068, 13.947],
                                        [-25.771, 0],
                                        [0, -25.771],
                                        [17.271, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [43.541, 23.331],
                                        [3.121, 46.662],
                                        [-43.541, 0],
                                        [3.121, -46.662],
                                        [43.541, -23.331]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.20000000298, 0.800000011921, 0.800000011921, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [246.879, 344.101], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "C",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [12.885, 0],
                                        [0, 0],
                                        [0, 12.885],
                                        [0, 0],
                                        [-12.885, 0],
                                        [0, 0],
                                        [0, -12.885],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-12.885, 0],
                                        [0, 0],
                                        [0, -12.885],
                                        [0, 0],
                                        [12.885, 0],
                                        [0, 0],
                                        [0, 12.885]
                                    ],
                                    "v": [
                                        [116.655, 93.324],
                                        [-116.655, 93.324],
                                        [-139.985, 69.993],
                                        [-139.985, -69.993],
                                        [-116.655, -93.324],
                                        [116.655, -93.324],
                                        [139.985, -69.993],
                                        [139.985, 69.993]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.023529412225, 0.023529412225, 0.023529412225, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [250, 344.101], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Mask",
            "parent": 1,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 2, "s": [0] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 13, "s": [10] },
                        { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 20, "s": [10] },
                        { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 26, "s": [-9] },
                        { "t": 36, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [189.985, 237.425, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [389.985, 437.425, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [12.885, 0],
                                        [0, 0],
                                        [0, 12.885],
                                        [0, 0],
                                        [-12.885, 0],
                                        [0, 0],
                                        [0, -12.885],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-12.885, 0],
                                        [0, 0],
                                        [0, -12.885],
                                        [0, 0],
                                        [12.885, 0],
                                        [0, 0],
                                        [0, 12.885]
                                    ],
                                    "v": [
                                        [116.655, 93.324],
                                        [-116.655, 93.324],
                                        [-139.985, 69.993],
                                        [-139.985, -69.993],
                                        [-116.655, -93.324],
                                        [116.655, -93.324],
                                        [139.985, -69.993],
                                        [139.985, 69.993]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [250, 344.101], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Lock 2",
            "parent": 2,
            "tt": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [343.647, 321.778, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [93.647, 151.507, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 2,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [51.541, 0],
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-25.771, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [-51.541, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0],
                                                    [25.771, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [93.647, 151.507],
                                                    [93.324, -14.372],
                                                    [0, -107.695],
                                                    [0, -107.695],
                                                    [-93.324, -14.372],
                                                    [-93.324, 107.695],
                                                    [-46.662, 107.695],
                                                    [-46.662, -14.372],
                                                    [0, -61.034],
                                                    [0, -61.034],
                                                    [46.662, -14.372],
                                                    [46.985, 151.507]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [51.541, 0],
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-25.771, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [-51.541, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0],
                                                    [25.771, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [93.647, 151.507],
                                                    [93.324, -14.372],
                                                    [0, -107.695],
                                                    [0, -107.695],
                                                    [-93.324, -14.372],
                                                    [-92.389, 49.651],
                                                    [-45.727, 49.651],
                                                    [-46.662, -14.372],
                                                    [0, -61.034],
                                                    [0, -61.034],
                                                    [46.662, -14.372],
                                                    [46.985, 151.507]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [51.541, 0],
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-25.771, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [-51.541, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0],
                                                    [25.771, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [93.647, 151.507],
                                                    [93.324, -14.372],
                                                    [0, -107.695],
                                                    [0, -107.695],
                                                    [-93.324, -14.372],
                                                    [-92.389, 49.651],
                                                    [-45.727, 49.651],
                                                    [-46.662, -14.372],
                                                    [0, -61.034],
                                                    [0, -61.034],
                                                    [46.662, -14.372],
                                                    [46.985, 151.507]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 36,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [51.541, 0],
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [-25.771, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, -51.541],
                                                    [0, 0],
                                                    [-51.541, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -25.771],
                                                    [0, 0],
                                                    [25.771, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [93.647, 151.507],
                                                    [93.324, -14.372],
                                                    [0, -107.695],
                                                    [0, -107.695],
                                                    [-93.324, -14.372],
                                                    [-93.324, 107.695],
                                                    [-46.662, 107.695],
                                                    [-46.662, -14.372],
                                                    [0, -61.034],
                                                    [0, -61.034],
                                                    [46.662, -14.372],
                                                    [46.985, 151.507]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.20000000298, 0.800000011921, 0.800000011921, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 2,
                                        "s": [0, 0],
                                        "to": [0, -4.333],
                                        "ti": [0, 4.333]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 0.667 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 13,
                                        "s": [0, -26],
                                        "to": [0, 0],
                                        "ti": [0, 0]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 20,
                                        "s": [0, -26],
                                        "to": [0, 17.333],
                                        "ti": [0, -4.333]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 26,
                                        "s": [0, 78],
                                        "to": [0, 4.333],
                                        "ti": [0, 13]
                                    },
                                    { "t": 36, "s": [0, 0] }
                                ],
                                "ix": 2
                            },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
